import script from "./ptxds_notice.vue?vue&type=script&setup=true&lang=js"
export * from "./ptxds_notice.vue?vue&type=script&setup=true&lang=js"

import "./ptxds_notice.vue?vue&type=style&index=0&id=85fb49c6&lang=less"

const __exports__ = script;

export default __exports__